:host {
  display: block;
}

.header {
  width: 100%;
}
.header .info {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.footer {
  display: flex;
  justify-content: center;
}

@media (max-width: 511px) {
  .header {
    display: block;
  }
}

.noResultsMessage {
  text-align: center;
}

.noResultsBannerImage {
  max-width: 100%;
  margin-top: var(--klevu-spacing-04);
}
